/**
 * Event handlers for ConfirmModal
 * Extracted to reduce component size
 */

export interface ConfirmModalHandlers {
	handleConfirm: () => Promise<void>;
	handleCancel: () => void;
	handleClose: () => void;
}

export interface BuildHandlersParams {
	requireConfirmation?: {
		enabled: boolean;
		expectedValue: string;
	};
	confirmationValue: string;
	setConfirmationValue: (value: string) => void;
	confirmButton?: {
		onClick: () => void | Promise<void>;
	};
	onConfirm?: () => void | Promise<void>;
	cancelButton?: {
		onClick?: () => void;
	};
	onCancel?: () => void;
	onClose: () => void;
}

/**
 * Builds event handlers for ConfirmModal
 */
export function buildConfirmModalHandlers(params: BuildHandlersParams): ConfirmModalHandlers {
	const {
		requireConfirmation,
		confirmationValue,
		setConfirmationValue,
		confirmButton,
		onConfirm,
		cancelButton,
		onCancel,
		onClose,
	} = params;

	const handleConfirm = async (): Promise<void> => {
		const ev = requireConfirmation?.enabled ? requireConfirmation.expectedValue : null;
		if (ev != null && (typeof ev !== "string" || ev.trim().length === 0 || confirmationValue !== ev)) {
			return;
		}
		if (confirmButton?.onClick) {
			await confirmButton.onClick();
		} else if (onConfirm) {
			await onConfirm();
		}
	};

	const handleCancel = (): void => {
		if (cancelButton?.onClick) {
			cancelButton.onClick();
		} else if (onCancel) {
			onCancel();
		} else {
			onClose();
		}
	};

	const handleClose = (): void => {
		setConfirmationValue("");
		onClose();
	};

	return { handleConfirm, handleCancel, handleClose };
}
